import React from "react";
import styled from "styled-components";
import Logo from "./logo.svg";
import PhoneIcon from "./phone.svg";
import EmailIcon from "./email.svg";

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    align-content: flex-start;
    margin: auto;
    margin-bottom: 50px;
    margin-top: 50px;
`;

const Left = styled.div`
    display: flex;
    flex: 0 0 189px;
    flex-direction: column;
    img{
        width: 189px;
        height: 45px;
    }
`;

const Right = styled.div`
    display: flex;
    flex: 0 0 calc(100% - 189px);
    justify-content: flex-start;
    flex-direction: column;
    text-align: right;
`;

const TelNo = styled.div`
    font-weight: bold;
    color: #131313;
    font-size: 19px;
    a{
        color: #131313;
        text-decoration: none;
    }
    a:active{
        color: #D0021B;
    }
`;

const Email = styled.div`
    font-weight: normal;
    font-size: 19px;
    margin-top: 16px;
    a{
        color: rgba(0,59,122,1.00);
    }
    a:active{
        color: #D0021B;
    }
`;

const Name = styled.div`
    margin-right: 10px;
    display: inline-block;
`;



const Header = () => (
<Container >
    <Left>
        <a href="/"><img src={Logo} alt="Advanced Spray Decorators" /></a>
    </Left>
    <Right>
        <TelNo>
            <Name>Chris<img src={PhoneIcon} alt="Phone" style={{marginLeft: "10px"}}/>
                
            </Name>
            <a href="tel:07889 690 069">07889 690 069</a>
        </TelNo>
        
        <TelNo>
            <Name>Ray<img src={PhoneIcon} alt="Phone" style={{marginLeft: "10px"}}/></Name>
            <a href="tel:07888-755-297">07888 755 297</a>
        </TelNo>
        <Email>
        <img src={EmailIcon} alt="Phone" style={{marginRight: "10px"}}/>
            <a href="mailto:contact@advancedspraydecorators.co.uk">Email Us</a>
        </Email>
    </Right>
</Container>
);

export default Header;


// WEBPACK FOOTER //
// ./src/components/header/header.js